/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconTelescope4 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M3.25 12.75h14.5a1 1 0 0 1 1 1v9.5h0-16.5 0v-9.5a1 1 0 0 1 1-1zM16.5 12.75a6 6 0 1 0-12 0" />
        <path d="M10.5 6.75V4.743a.92.92 0 0 1 .346-.709 1.1 1.1 0 0 1 .806-.233 9.436 9.436 0 0 1 8.575 7.889.9.9 0 0 1-.254.741 1.071 1.071 0 0 1-.77.319H17.25" />
        <path d="M15.975 5.258l1.904-1.922 2.809 2.835-1.843 1.86" />
        <path d="M19.707 5.18l-.877-.88a2.37 2.37 0 0 1 0-3.336l.033-.033a.59.59 0 0 1 .836-.006l.006.006 3.37 3.4a.605.605 0 0 1 0 .851h0a2.37 2.37 0 0 1-3.352.014l-.016-.016zM8.75 16.5h3.5a.5.5 0 0 1 .5.5v6.25h0-4.5 0V17a.5.5 0 0 1 .5-.5zM.75 23.25h19.5" />
      </g>
    </svg>
  ),
);
